export enum mediaCenterEvents {
  MEDIA_CENTER_OPEN = "media-library-open",
  MEDIA_CENTER_SELECTED = "mediaSelected",
}

export enum MediaCenterAllowedExtensions {
  IMAGE = "image",
  VIDEO = "video",
  DOCUMENT = "document",
  AUDIO = "audio",
}

export enum MediaCenterContentType {
  IMAGE = "image",
  VIDEO = "video",
  DOCUMENT = "application",
  AUDIO = "audio",
}

export enum MediaCenterAltType {
  LOCATION = "location",
  AGENCY = "agency",
}

export enum MediaCenterCategory {
  FORMS = "forms",
}

export enum MediaCenterSubCategory {
  FORM = "form_builder",
  SURVEY = "survey_builder",
  QUIZ = "quiz_builder",
}

export interface MediaLibrarySettings {
  allowedExtensions?: MediaCenterAllowedExtensions[];
  maxUploadSize?: {
    video?: number;
    audio?: number;
    document?: number;
    image?: number;
  };
  selfHosted?: boolean;
  contentType?: MediaCenterContentType;
  contentAi?: boolean;
  allowMultipleFileInsertion?: boolean;
  hideHeader?: boolean;
  category?: MediaCenterCategory;
  subCategory: MediaCenterSubCategory;
}

export interface IMediaCenterSelection {
  altId: string;
  altType: MediaCenterAltType;
  encodingInProgress: boolean;
  height: number;
  id: string;
  isEncoded: boolean;
  name: string;
  processingStartedAt: number;
  size: number;
  type: string;
  url: string;
  width: number;
}
